<template lang="html">
  <div class="monitor">
    <v-header :name="name"></v-header>
    <div class="container">
      <img class="left-bg" src="../../../static/img/video/bg-left.png" alt="">
      <img class="right-bg" src="../../../static/img/video/bg-right.png" alt="">

      <div class="top">
        <!-- <select class="select" v-model="chose">
          <option class="icon" v-for="option in options" v-bind:value="option.value">
            <input type="checkbox" v-model="toggle">{{option.text}}</option>
        </select> -->
        <div class="select"  @click="up">
          <div class="name">百色市监控</div>
          <div class="oprate" v-show="show">收起 <img style="transform:rotate(180deg)" src="../../../static/img/video/down.png" alt=""></div>
          <div class="oprate" v-show="!show">展开 <img  src="../../../static/img/video/down.png" alt=""></div>
          <div class="options" v-show="show">
            <div style="display:flex" v-for="(item,index) in options" :key="item.id">
              <div>
                <input :id="ids(index)" class="cb" :value="item.text" type="checkbox" v-model="checkedNames2">
                <label :for="ids(index)"></label>
                </div>
              <div class="icon">{{item.text}}</div>
            </div>
          </div>
        </div>
        
        <div class="total">
          <span>百色市监控总数</span>
          <span>60个</span>
        </div>
        <div class="change">
          <!-- <div class="head" @click="toggles(index)" v-for="(item, index) in header" :style="tog(index)" :style={back}></div> -->
          <div class="head" @click="keys(1)" :class="{ cr: status }" >
          </div>
          <div class="head cur2" @click="keys(2)" :class="{ cr2: status1}" >
          </div>
          <div class="head cur3"  @click="keys(3)" :class="{ cr3: status2   }">
          </div>
          <div class="head cur4"  @click="keys(4)" :class="{ cr4: status3   }" >
          </div>
          <!-- <img @click="change(1)" :src="{seq == 1 ? cp : cp01}"  alt="">
          <img @click="change(4)" :src="{seq == 4 ? cp : cp01}" alt="">
          <img @click="change(9)" :src="{seq == 1 ? cp : cp01}" alt="">
          <img @click="change(16)" :src="{seq == 1 ? cp : cp01}" alt=""> -->
        </div>
      </div>
      <div class="bottom">
        <div class="left">
          <img src="../../../static/img/video/pic.png" alt="">
        </div>
        <div class="right">
          <div class="pic-item" :id="ID(index)" :style="width()" :class="width2()" v-for="(item, index) in showList" :key="index">
            <img :src="item" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import header from 'components/common/header'
import cp from '../../../static/img/video/change1.png'
import cp1 from '../../../static/img/video/change2.png'
import cp2 from '../../../static/img/video/change3.png'
import cp3 from '../../../static/img/video/change4.png'
import pic1 from '../../../static/img/video/pic1.png'
import pic2 from '../../../static/img/video/pic2.png'
import pic3 from '../../../static/img/video/pic3.png'
import pic4 from '../../../static/img/video/pic4.png'
import pic5 from '../../../static/img/video/pic5.png'
import pic6 from '../../../static/img/video/pic6.png'
import pic7 from '../../../static/img/video/pic7.png'
import pic8 from '../../../static/img/video/pic8.png'
import pic9 from '../../../static/img/video/pic9.png'
export default {
  data() {
    const that = this;
    return {
      name: '田阳县农业大脑——监控展示中心',
      show: false,
      key: 0,
      checkedNames: [],
      header: [1, 1, 1, 1],
      n1: 1,
      n2: 1,
      n3: 1,
      n4: 1,
      checkedNames2: ['田阳县基地监控'],
      options: [
        { text: '田阳县基地监控', value: true },
        { text: '田阳县基地监控1', value: false },
        { text: '田阳县基地监控2', value: false },
        { text: '田阳县基地监控3', value: false },
        { text: '田阳县基地监控4', value: false },
        { text: '田阳县基地监控5', value: false },
        { text: '田阳县基地监控6', value: false },
        { text: '田阳县基地监控7', value: false },
        { text: '田阳县基地监控8', value: false },
        { text: '田阳县基地监控9', value: false },
        { text: '田阳县基地监控10', value: false },
        { text: '田阳县基地监控11', value: false },
        { text: '田阳县基地监控12', value: false },
        { text: '田阳县基地监控13', value: false },
        { text: '田阳县基地监控14', value: false },
        { text: '田阳县基地监控15', value: false },
        { text: '田阳县基地监控16', value: false }
      ],
      showList: [pic1],
      picList: [
        pic1,
        pic2,
        pic3,
        pic4,
        pic5,
        pic6,
        pic7,
        pic8,
        pic9,
        pic5,
        pic6,
        pic7,
        pic8,
        pic9,
        pic5,
        pic6
      ],
      status: true,
      status1: false,
      status2: false,
      status3: false,
      seq: 1
    }
  },
  mounted() {
  },
  watch: {
    checkedNames2: function (val, oldVal) {
      let n = val.length
      this.checkedNames2 = val
      this.showList = this.picList.slice(0, n)
    }
  },
  methods: {
    keys (ind) {
      if (ind === 1) {
        this.checkedNames2 = this.checkedNames2.slice(0, 1)
        this.width2(1)
        this.n1++
        this.status = true
        this.status1 = false
        this.status2 = false
        this.status3 = false
      }
      if (ind === 2) {
        // if (this.checkedNames2.length < 4) {
        //   let self = this
        //   self.checkedNames2 = []
        //   for (let i = 0; i < 4; i++) {
        //     self.checkedNames2.push(self.options[i].text)
        //   }
        // }
        this.checkedNames2 = this.checkedNames2.slice(0, 4)
        this.width2(2)
        this.n2++
        this.status1 = true
        this.status = false
        this.status2 = false
        this.status3 = false
      }
      if (ind === 3) {
        // if (this.checkedNames2.length < 9) {
        //   let self = this
        //   self.checkedNames2 = []
        //   for (let i = 0; i < 9; i++) {
        //     self.checkedNames2.push(self.options[i].text)
        //   }
        // }
        this.checkedNames2 = this.checkedNames2.slice(0, 9)
        this.width2(3)
        this.n3++
        this.status2 = true
        this.status1 = false
        this.status = false
        this.status3 = false
      }
      if (ind === 4) {
        // if (this.checkedNames2.length < 16) {
        //   let self = this
        //   self.checkedNames2 = []
        //   for (let i = 0; i < 16; i++) {
        //     self.checkedNames2.push(self.options[i].text)
        //   }
        // }
        this.checkedNames2 = this.checkedNames2.slice(0, 16)
        this.width2(4)
        this.n4++
        this.status3 = true
        this.status1 = false
        this.status2 = false
        this.status = false
      }
    },
    tog (key) {
      if (key === 1) {
        return "background-image:url('../../../static/img/video/change2.png')"
      }
      if (key === 2) {
        return "background-image:url('../../../static/img/video/change3.png')"
      }
      if (key === 3) {
        return "background-image:url('../../../static/img/video/change4.png')"
      }
    },
    ID (index) {
      return 'pic' + index
    },
    print () {
      console.log(this.options)
    },
    up () {
      this.show = !this.show
    },
    change (index) {
      if (index === 1) {
        this.checkedNames2 = this.checkedNames2.slice(0, 1)
        this.width(1)
      }
      if (index === 4) {
        this.checkedNames2 = this.checkedNames2.slice(0, 4)
        this.width(2)
      }
      if (index === 9) {
        this.checkedNames2 = this.checkedNames2.slice(0, 9)
      }
      if (index === 16) {
        this.checkedNames2 = this.checkedNames2.slice(0, 16)
        this.width(4)
      }
      console.log(index)
    },
    width2 (key) {
      if (key === 1) {
        return "pic1"
      }
      if (key === 2) {
        return "pic2"
      }
      if (key === 4) {
        return "pic4"
      }
    },
    width (key) {
      if (this.status) {
        return "width:94%;height:750px;background-image:url('../../../static/img/video/bg4.png');background-size:100% 100%"
      }
      if (this.status1) {
        return "width:44%;height:360px;margin:1% 2%;"
      }
      if (this.status2) {
        return "width: 278px;height: 240px;margin-right: 22px;margin-bottom: 15px;padding: 30px;"
      }
      if (this.status3) {
        return "width:22%;height:170px;margin:1%;"
      }
    },
    ids (index) {
      return "checkbox" + index
    }
  },
  components: {
    'v-header': header
  }
}

</script>

<style lang="stylus" scoped>
 input[type="checkbox"] {
    display: none;
}
[id^="checkbox"] + label {
  background:url('../../../static/img/video/cb.png') no-repeat 0 0;
  background-size: 100%;
  border: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 9px;
  border-radius: 5px;
  display: inline-block;
  position: relative;
  margin-right: 10px;
}

[id^="checkbox"] + label:active {
    box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1);
}
[id^="checkbox"]:checked + label {
    background-color: #ECF2F7;
    border: none;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05), inset 15px 10px -12px rgba(255, 255, 255, 0.1);
    color: #243441;
}
[id^="checkbox"]:checked + label:after {
    content: '\2715';
    position: absolute;
    top: 0px;
    left: 0px;
    color: rgba(0,0,0,0);/*可设置非透明色之后，查看效果*/
    width: 100%;
    text-align: center;
    font-size: 16px;
    padding: 1px 0 0 0;
    vertical-align: text-top;
    background: url('../../../static/img/video/cbc.png') no-repeat 0 0;background-size: 100%;
}
.monitor {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: url('../../../static/img/common/bg.png');
  background-size: 100% 100%;
}

.container {
  height: 100%;
  padding: 26px 30px 0;
  box-sizing: border-box;
  position: relative;

  .left-bg {
    position: absolute;
    left: 0px;
    top: 80px;
  }

  .right-bg {
    position: absolute;
    right: 0px;
    top: 80px;
  }

  .top {
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      height: 108px;
      line-height: 108px;
      width: 508px;
      background: url('../../../static/img/video/bg2.png') no-repeat;
      background-size: cover
      border:none; 
      display: flex;
      align-items :center
      position: relative
      .options {
        position:absolute 
        width: 450px
        background :rgba(0, 36, 90, .7)
        border:1px solid rgba(73, 117, 233, 1);
        left:60px
        top:100px
        padding: 10px
        line-height 40px
        input {
          width:20px
          height:20px
          margin-top:10px
          background:url('../../../static/img/video/cb.png') no-repeat
          background-size :cover
        }
        .icon {
          padding-left:30px
          margin:0 10px
          background:url('../../../static/img/video/icon.png') left 10px no-repeat;
          background-size: 20px
        }
        div {
          font-size:18px
         
        }
      }
      .name {
        width: 75%;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        font-size: 30px;
      }

      .oprate {
        color: rgba(82, 255, 255, 1);
        font-size: 20px;
        img {
          vertical-align: middle;
          margin-left: 5px;
        }
      }
    }

    .total {
      font-size: 24px;
      height: 78px;
      line-height: 78px;
      width: 466px;
      background: url('../../../static/img/video/bg3.png') no-repeat;

      span:nth-child(1) {
        border-right: 1px solid #125BE0;
        padding: 0 50px;
      }

      span:nth-child(2) {
        padding: 0 50px;
      }
    }

    .change {
      display: flex;
      justify-content: space-between;
      height: 108px;
      width: 508px;
      padding:0 50px
      padding-top: 30px;

      background: url('../../../static/img/video/bg1.png') no-repeat;
      .head {
        width:46px
        height 46px
        background: url('../../../static/img/video/change1.png') no-repeat
      }
      .cur2 {
        background-image: url('../../../static/img/video/change2.png') 
      }
      .cur3 {
        background-image: url('../../../static/img/video/change3.png') 
      }
      .cur4 {
        background-image: url('../../../static/img/video/change4.png') 
      }
      .cr {
         background-image: url('../../../static/img/video/change01.png') 
      }
      .cr2 {
         background-image: url('../../../static/img/video/change02.png') 
      }
      .cr3 {
         background-image: url('../../../static/img/video/change03.png') 
      }
      .cr4 {
         background-image: url('../../../static/img/video/change04.png') 
      }
      img {
        height: 46px;
        width: 46px;
        margin-right: 54px;
      }
    }
  }

  .bottom {
    display: flex;
    margin-top: 42px;

    .left {
      width: 910px;
      height: 750px;
      background: url('../../../static/img/video/bg4.png') no-repeat;
      padding: 26px 22px;
      box-sizing: border-box;
      margin-right: 30px;
    }

    .right {
      display: flex;
      flex-wrap: wrap;
      width:980px;
      height: 750px;
      overflow: hidden;
      .pic-item {
        width: 278px;
        height: 240px;
        background: url('../../../static/img/video/bg5.png') no-repeat;
        background-size: cover
        margin-right: 22px;
        margin-bottom: 15px;
        padding: 30px;
        box-sizing: border-box;
        img {
          width: 100%
        }
      }
      .pic1 {
        width:94%
        height: 750px
      }
      .pic2 {
        width:44%
        height:360px
        margin:1% 2%
      }
      .pic3 {
        width:22%
        height:170px
        margin:1%
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?0e3a4c48